import { auth } from "@/endpoints/dryp/auth";
import { useAsyncStateStore } from "@/hooks/useAsyncStateStore";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";

export const useOnboard = () => {
	const [searchParams] = useSearchParams();
	const token = searchParams.get("token");
	const navigate = useNavigate();
	const validateTokenApi = useAsyncStateStore(auth.validateOnboardToken);

	useEffect(() => {
		if (token) {
			validateTokenApi.fetch({ token });
		} else {
			navigate("/404");
		}
	}, [token, validateTokenApi, navigate]);

	return {
		isValidatingToken: !validateTokenApi.loaded,
		isValidationTokenExpired: validateTokenApi.loaded && !validateTokenApi.success,
		onbaordData: validateTokenApi.data,
		token: token || "",
	};
};
